import createAxiosInstance from "./axios";

let API_SERVER_PREFIX =
    process.env.REACT_APP_SERVER_DOMAIN +
    process.env.REACT_APP_SERVER_ENVIRONMENT;

const { getRequest, postRequest } = createAxiosInstance(API_SERVER_PREFIX);

export const getOBDashboardStep = () =>
    getRequest(`certification/get-onboarding-screen`);

export const updateOBDashboardStep = (request) =>
    postRequest(`certification/update-onboarding-screen`, request);

export const getQuestionnaire = (questionnaireType) =>
    getRequest(
        `certification/get-questions?questionnaireType=${questionnaireType}`,
    );

export const autoSaveQuestionnaire = (questionnaire) =>
    postRequest(`certification/api/auto-save-answer`, questionnaire);

export const submitScenario = (questionnaire) =>
    postRequest(`certification/api/submit-scenario`, questionnaire);

export const getAuthToken = (requestBody) =>
    postRequest(`certification/get-token`, requestBody);

export const generateAuthToken = (requestBody) =>
    postRequest(`certification/generate-token`, requestBody);

export const getPullClientsMetadataFilesUrlPrefix = (requestBody) =>
    postRequest(
        `certification/getPullClientsMetadataFilesUrlPrefix`,
        requestBody,
    );
export const getClientDocuments = () =>
    getRequest(`certification/getClientDocuments`);

export const getClientDocumentUrl = (fileName) =>
    getRequest(`certification/getClientDocumentUrl?fileName=${fileName}`);

export const getClientInfo = (clientCode) => {
    return getRequest(`/client/info/${clientCode}`);
};

export const submitConfiguration = (configData) => {
    return postRequest("/configuration/submit", configData);
};

export const getConfiguration = (clientId) => {
    return getRequest(`/configuration/${clientId}`);
};

export const getPreferences = (clientId, type) => {
    return getRequest(`/preferences/search/${clientId}?type=${type}`);
};

export const savePreferences = (clientId, preferences) => {
    return postRequest(`/preferences/${clientId}`, preferences);
};

export const getProperties = (clientId, searchString) => {
    return getRequest(
        `/content-api/property/${clientId}?searchString=${searchString}`,
    );
};

export const getRateplans = (propertyId) => {
    return getRequest(`/content-api/rateplans/${propertyId}`);
};

export const getRoomtypes = (propertyId) => {
    return getRequest(`/content-api/roomtypes/${propertyId}`);
};

export const getTaxes = (propertyId) => {
    return getRequest(`/content-api/taxes/${propertyId}`);
};

export const getPolicies = (propertyId) => {
    return getRequest(`/content-api/policies/${propertyId}`);
};

export const pushContentAPI = (data) => {
    return postRequest("/content-api/push", data);
};

export const auditContentAPI = (data) => {
    return postRequest("/content-api/audit", data);
};
